export default __webpack_public_path__ + "static/img5-6fc88a26751eba87c96bf56040072dd1.png";